export const WORKORDER_PRIORITY_HIGH = 2;
export const WORKORDER_PRIORITY_MEDIUM = 1;
export const WORKORDER_PRIORITY_LOW = 0;

export const WORKORDER_STATUS_NEW = 0;
export const WORKORDER_STATUS_MAINTENANCE = 1;
export const WORKORDER_STATUS_OPERATION = 2;
export const WORKORDER_STATUS_COMPLETED = 3;
export const WORKORDER_STATUS_INPROGRESS = 1;
export const WORKORDER_STATUS_CLOSED = 2;
